import { NgModule } from '@angular/core';
import { CallbackPipe } from './callback.pipe';
import {
  sizeFormat,
  toFixedFormat,
  lengthFormat,
  momentFormat,
  ucFirst,
  Join,
  SafeHtml,
  LabelByIdFilter,
  LabelByArrayFilter,
  ReplaceLineBreaks,
  AddIconForBreakTitle,
  addCharacterAtPosition,
  separateNumberWithCharacters,
} from './format.pipe';
import { ArraySortPipe, ReversePipe } from './sorts.pipe';
import {
  FilterByKeyValue,
  SearchByValue,
  SearchByKeyValue,
  minDate,
  maxDate,
  isToday,
  isTomorrow,
  FilterByObject,
  isWeek,
  isMonth,
  StartWithByKeyValue,
  AdvancedSearch,
  removeEmptyLabel,
  FilterByStateActiveInactiveContact,
  FilterByPropertyNotNull,
  FilterByPropertyIsNull,
  FilterByPropertyGiven,
} from './filter.pipe';
import { QrCodeExplodeRegexpFull } from './qrCode.pipe';

@NgModule({
  declarations: [
    CallbackPipe,
    sizeFormat,
    toFixedFormat,
    lengthFormat,
    momentFormat,
    FilterByObject,
    ArraySortPipe,
    ReversePipe,
    FilterByKeyValue,
    SearchByValue,
    SearchByKeyValue,
    minDate,
    maxDate,
    ucFirst,
    isToday,
    isTomorrow,
    isWeek,
    isMonth,
    StartWithByKeyValue,
    Join,
    SafeHtml,
    LabelByIdFilter,
    AdvancedSearch,
    FilterByStateActiveInactiveContact,
    LabelByArrayFilter,
    removeEmptyLabel,
    ReplaceLineBreaks,
    AddIconForBreakTitle,
    addCharacterAtPosition,
    separateNumberWithCharacters,
    FilterByPropertyNotNull,
    FilterByPropertyIsNull,
    FilterByPropertyGiven,
    QrCodeExplodeRegexpFull,
  ],
  imports: [],
  exports: [
    CallbackPipe,
    sizeFormat,
    toFixedFormat,
    lengthFormat,
    momentFormat,
    FilterByObject,
    ArraySortPipe,
    ReversePipe,
    FilterByKeyValue,
    SearchByValue,
    SearchByKeyValue,
    minDate,
    maxDate,
    ucFirst,
    isToday,
    isTomorrow,
    isWeek,
    isMonth,
    StartWithByKeyValue,
    Join,
    SafeHtml,
    LabelByIdFilter,
    AdvancedSearch,
    FilterByStateActiveInactiveContact,
    LabelByArrayFilter,
    removeEmptyLabel,
    ReplaceLineBreaks,
    AddIconForBreakTitle,
    addCharacterAtPosition,
    separateNumberWithCharacters,
    FilterByPropertyNotNull,
    FilterByPropertyIsNull,
    FilterByPropertyGiven,
    QrCodeExplodeRegexpFull,
  ],
  providers: [],
})
export class PipesModule {}
